var _style, _path, _path2, _g, _g2, _g3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolygonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.2 18.5",
    style: {
      enableBackground: "new 0 0 16.2 18.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#D9D9D9;}\n\t.st1{fill:none;stroke:#D9D9D9;stroke-width:1.1087;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.7,14.1l-5.6-3.2V4.2L7,0.9l5.7,3.3v4.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9,16.8L8.5,9l6.2,4.5h-3.9L9,16.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(836 23.816)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -834.8,
    cy: -13.1,
    r: 0.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(836 23.816)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -829.3,
    cy: -9.7,
    r: 0.6
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(836 23.816)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -823.3,
    cy: -15.3,
    r: 0.6
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(836 23.816)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -823.3,
    cy: -19.6,
    r: 0.6
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(836 23.816)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -829,
    cy: -22.7,
    r: 0.6
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(836 23.816)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -834.8,
    cy: -19.6,
    r: 0.6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonIcon);
export default __webpack_public_path__ + "static/media/polygon-icon.b36f5616.svg";
export { ForwardRef as ReactComponent };